import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { isObjectEmptyValidator } from '../validators/is-object-empty-validator';

export const useQuery = () => {
  const history = useHistory();
  const { search } = useLocation();

  const [isInit, setIsInit] = useState(false);
  const [isEmpty, setIsEmpty] = useState(true);
  const [queryParamsObject, setQueryParamsObject] = useState<
    Record<string, string>
  >({});
  const [queryParams, setQueryParams] = useState(new URLSearchParams(search));

  useEffect(() => {
    const queryObject: Record<string, string> = {};
    for (const [key, value] of queryParams) {
      queryObject[key] = value;
    }

    setIsInit(true);
    setIsEmpty(isObjectEmptyValidator(queryObject));
    setQueryParamsObject(queryObject);
  }, [queryParams]);

  const updateParams = (newParams: Record<string, string>): void => {
    const newSearchParams = queryParams;

    for (const key in newParams) {
      newSearchParams.set(key, newParams[key]);
    }

    setQueryParams(newSearchParams);

    history.replace({
      pathname: location.pathname,
      search: newSearchParams.toString(),
    });
  };

  const removeQueryParam = (paramName: string) => {
    const newSearchParams = new URLSearchParams(queryParams.toString());
    newSearchParams.delete(paramName);
    history.replace({
      pathname: location.pathname,
      search: newSearchParams.toString(),
    });
    setQueryParams(newSearchParams);
  };

  return {
    query: queryParamsObject,
    setQuery: updateParams,
    clearQuery: removeQueryParam,
    isQueryInit: isInit,
    isQueryEmpty: isEmpty,
  };
};
